import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { RAW, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

// Deep merge: base (English) gets overridden by locale; arrays replaced wholesale when present.
function deepMerge(base, override) {
  if (override === undefined || override === null) return base;
  if (Array.isArray(base) || Array.isArray(override)) {
    return override !== undefined ? override : base;
  }
  if (typeof base === "object" && typeof override === "object") {
    const out = { ...base };
    for (const key of Object.keys(override)) {
      out[key] = deepMerge(base[key], override[key]);
    }
    return out;
  }
  return override !== undefined ? override : base;
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("habitus_lang") || "en");

  const t = useMemo(() => deepMerge(RAW.en, RAW[lang] || {}), [lang]);
  const dir = t.meta?.dir || "ltr";

  useEffect(() => {
    localStorage.setItem("habitus_lang", lang);
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang, dir]);

  const value = { lang, setLang, t, dir, languages: LANGUAGES };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
